const normalizeSupplierId = (value) =>
  typeof value === 'string' ? value.trim() : '';

export const noPriceYetLabel = 'No Price Yet';

export const getSupplierPriceDisplay = (hasPriceHistory, formattedPrice) =>
  hasPriceHistory ? formattedPrice : noPriceYetLabel;

export const buildProductSupplierMap = (productSuppliers) =>
  (Array.isArray(productSuppliers) ? productSuppliers : []).reduce(
    (lookup, productSupplier) => {
      const productSupplierId = normalizeSupplierId(productSupplier?.id);

      if (productSupplierId) {
        lookup[productSupplierId] = productSupplier;
      }

      return lookup;
    },
    {}
  );

export const getSupplierIdForVariant = (variant, productSupplierMap) =>
  normalizeSupplierId(
    variant?.supplierId ||
    productSupplierMap[normalizeSupplierId(variant?.productSupplierId)]?.supplierId
  );

export const getLinkedSupplierIds = (
  productSuppliers,
  productVariants,
  productSupplierMap = buildProductSupplierMap(productSuppliers)
) =>
  Array.from(
    new Set(
      [
        ...(Array.isArray(productSuppliers) ? productSuppliers : []).map(
          (productSupplier) => normalizeSupplierId(productSupplier?.supplierId)
        ),
        ...(Array.isArray(productVariants) ? productVariants : []).map((variant) =>
          getSupplierIdForVariant(variant, productSupplierMap)
        ),
      ].filter(Boolean)
    )
  );

export const buildSuppliersById = (...supplierLists) =>
  supplierLists.flatMap((suppliers) => (Array.isArray(suppliers) ? suppliers : []))
    .reduce((lookup, supplier) => {
      const supplierId = normalizeSupplierId(supplier?.id);

      if (supplierId) {
        lookup[supplierId] = supplier;
      }

      return lookup;
    }, {});

export const buildPricingSuppliersById = (linkedSuppliers) =>
  buildSuppliersById(linkedSuppliers);

export const buildSupplierPricingRow = (productSupplier, suppliersById) => {
  const supplierId = normalizeSupplierId(productSupplier?.supplierId);
  const supplier = suppliersById[supplierId];

  if (!supplierId) {
    return null;
  }

  if (!supplier) {
    return null;
  }

  return {
    supplierId,
    supplierName: supplier.companyName || supplier.name || 'Archived Supplier',
    isTrashed: supplier.isDeleted === true,
    isMissingSupplier: false,
  };
};
